var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
export default function StripCalloutWithBackground(props) {
    var fields = props.fields;
    var TitleTag = (fields.titleTag || 'h1');
    return (React.createElement("div", __assign({ className: "strip spa-strip-cards " +
            fields.backgroundColor +
            (fields.borderBottom ? " border-bottom" : "") +
            (fields.topPadding ? " top-padding-" + fields.topPadding : "") +
            (fields.bottomPadding ? " bottom-padding-" + fields.bottomPadding : "") +
            (fields.topMargin ? " top-margin-" + fields.topMargin : "") +
            (fields.bottomMargin ? " bottom-margin-" + fields.bottomMargin : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {}), { style: { backgroundImage: "url(".concat(fields.backgroundImage, ")") } }),
        React.createElement("div", { className: 'container' },
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col-lg-4' }, fields.displayTitle &&
                    React.createElement(TitleTag, { className: "title " + fields.titleStyle, itemProp: "name", dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null),
                React.createElement("div", { className: 'col-lg-7 offset-lg-1' },
                    React.createElement("div", { className: 'testimonial-content' },
                        fields.icon && (React.createElement("div", { className: 'img-container' },
                            React.createElement("img", { className: 'img-fluid', src: fields.icon, alt: fields.icon_description, title: fields.icon_title }))),
                        fields.content && (React.createElement("div", { className: 'details', dangerouslySetInnerHTML: { __html: fields.content } })),
                        fields.author && (React.createElement("div", { className: 'author-details' },
                            React.createElement("div", { className: 'name', dangerouslySetInnerHTML: { __html: fields.author } }),
                            React.createElement("div", { className: 'function', dangerouslySetInnerHTML: { __html: fields.function } })))))))));
}
